import { NavLink, Outlet, Link } from 'react-router-dom';
import { ArrowLeft, Leaf } from 'lucide-react';
import AppIcon from '../AppIcon';
import { PageSeo } from '../Seo';
import { useAuth } from '../../context/AuthContext';

export default function AdminLayout() {
  const { user, logout } = useAuth();

  return (
    <>
      <PageSeo title="Yönetim Paneli" noindex />
      <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <span className="admin-brand-icon">
            <AppIcon icon={Leaf} size={28} />
          </span>
          <div>
            <strong>Yönetim Paneli</strong>
            <span>{user?.name}</span>
          </div>
        </div>

        <nav className="admin-nav">
          <NavLink to="/admin" end className={({ isActive }) => (isActive ? 'active' : '')}>
            Dashboard
          </NavLink>
          <NavLink to="/admin/products" className={({ isActive }) => (isActive ? 'active' : '')}>
            Ürünler
          </NavLink>
          <NavLink to="/admin/orders" className={({ isActive }) => (isActive ? 'active' : '')}>
            Siparişler
          </NavLink>
          <NavLink
            to="/admin/order-requests"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            İptal / İade
          </NavLink>
        </nav>

        <div className="admin-sidebar-footer">
          <Link to="/" className="admin-link-muted icon-inline-link">
            <ArrowLeft size={16} aria-hidden />
            Siteye Dön
          </Link>
          <button type="button" className="admin-link-muted" onClick={() => void logout()}>
            Çıkış
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
    </>
  );
}
